<template>
  <div class="map-style-list">
    <div
      v-for="style in getStyles"
      :key="style.name"
      :class="['map-list-item', 'smooth-shadow', { active: style.isActive }]"
      @click="setMapStyle(style.url)"
    >
      <img :src="style.image" :alt="style.name" />
      <p class="flex-expand">{{ style.name }}</p>
      <i v-if="style.isActive" class="material-icons mar-right-5"
        >check_circle</i
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters("Map", ["getMapStyle", "getStyles"]),
  },
  methods: {
    ...mapActions("Map", ["setMapStyle"]),
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.map-style-list {
  display: flex;
  flex-direction: column;
  padding: 15px;
  .map-list-item {
    padding: 10px;
    border-radius: 5px;
    background: var(--color-secondary);
    margin-bottom: 10px;
    border-left: 5px solid var(--font-color-unselected);
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: 0.3s all ease-in-out;

    &.active {
      border-left: 5px solid var(--color-primary);

      p {
        font-weight: bold;
        color: var(--color-primary);
      }
    }

    &:hover {
      cursor: pointer;
    }

    &:active {
      transform: scale(0.98);
    }

    img {
      position: relative;
      width: 50px;
      height: 50px;
      border-radius: 5px;
      margin-right: 10px;

      &[alt]:after {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #fff;
        font-family: "Helvetica";
        font-weight: 300;
        line-height: 2;
        text-align: center;
        content: attr(alt);
      }
    }

    i {
      color: var(--color-primary);
    }
  }
}
</style>
